export interface HotItem {
  id: number;
  tag: string;
  tagTone: "hot" | "accent" | "neutral";
  title: string;
  summary: string;
  time: string;
  views: string;
}

export interface DirectionItem {
  icon: string;
  name: string;
  english: string;
  desc: string;
  entry: string;
}

export interface TimelineCase {
  phase: string;
  date: string;
  title: string;
  body: string;
}

export interface FeatureItem {
  tag: string;
  title: string;
  excerpt: string;
  meta: string;
  image: string;
}

export interface ResourceItem {
  icon: string;
  title: string;
  desc: string;
  size: string;
  action: string;
}

export const hotList: HotItem[] = [
  { id: 1, tag: "娱乐内幕", tagTone: "hot", title: "某顶流偶像团体「塌房」前夜：三份未公开合约细节逐条还原", summary: "从资本对赌到商务解约，我们按公开线索把时间线拆到前一天，看到与通稿完全不同的版本。", time: "18 分钟前", views: "86.2w" },
  { id: 2, tag: "商业真相", tagTone: "accent", title: "某连锁品牌“爆雷”背后：加盟商合同里那页从不给你看的小字", summary: "宣传页强调高回报，真正的责任条款藏在附录第 11 条。我们把前后两版合同做了逐字对照。", time: "1 小时前", views: "54.7w" },
  { id: 3, tag: "行业潜规则", tagTone: "neutral", title: "直播间“破价”都是真的吗？一段内幕音频还原议价台前幕后", summary: "所谓的全网最低价，其实早在开播前就写进了排期表。内幕消息指向供应链压价的全链条。", time: "3 小时前", views: "41.3w" },
  { id: 4, tag: "科技未公开", tagTone: "accent", title: "某款“全自研”功能被扒出依赖第三方——官方回应与代码时间戳冲突", summary: "一面是发布会上反复强调的完全自研，一面是外部依赖的时间戳，谁在说真话仍需深挖。", time: "5 小时前", views: "33.9w" },
  { id: 5, tag: "娱乐内幕", tagTone: "neutral", title: "一份被涂改的片酬表：爆料人留存的备份揭示“友情价”真相", summary: "对外口径是零片酬出演，备份里却藏着分成条款。未公开细节让整件事变得耐人寻味。", time: "7 小时前", views: "29.1w" },
  { id: 6, tag: "社会复盘", tagTone: "hot", title: "一次辟谣声明的前后 48 小时：从发布、发酵到删除的完整路径", summary: "事件并未因一纸声明终结。我们还原了声明措辞被逐字修改的三版草稿，背后是连续博弈。", time: "9 小时前", views: "25.8w" },
];

export const directions: DirectionItem[] = [
  { icon: "ri-movie-2-line", name: "娱乐内幕", english: "ENTERTAINMENT", desc: "台前通稿之外，拆解偶像、综艺与片场的另一面。", entry: "进入深挖" },
  { icon: "ri-briefcase-4-line", name: "商业真相", english: "BUSINESS", desc: "品牌爆雷、加盟合同与资本对赌里的未公开细节。", entry: "进入深挖" },
  { icon: "ri-cpu-line", name: "科技未公开", english: "TECH", desc: "把“全自研”“遥遥领先”拉回证据层面逐一验证。", entry: "进入深挖" },
  { icon: "ri-money-dollar-circle-line", name: "行业潜规则", english: "INDUSTRY", desc: "直播间议价、报价与分成背后的真实玩法。", entry: "进入深挖" },
  { icon: "ri-focus-3-line", name: "社会复盘", english: "SOCIETY", desc: "重大舆情事件从发酵到声明前后的完整时间线。", entry: "进入深挖" },
  { icon: "ri-vip-diamond-line", name: "独家连载", english: "ORIGINALS", desc: "追更一个题材数月，把未公开细节做成长线专题。", entry: "开始追更" },
];

export const timelineCases: TimelineCase[] = [
  { phase: "第 01 阶段", date: "2024.06", title: "一张截图开始流传，传闻破土", body: "爆料人在评论区留下一句“水很深”，随后截图在多个群聊间快速转发，真伪尚无人核实。" },
  { phase: "第 02 阶段", date: "2024.07", title: "官方声明上线，口径与证据冲突", body: "声明用词审慎，却在几个关键时间点上与流出的票据对不上，这成为我们首次存疑的起点。" },
  { phase: "第 03 阶段", date: "2024.09", title: "内幕消息补上中间缺失的拼图", body: "多位不愿具名的当事人提供了彼此独立的细节，交叉比对后指向同一处被隐去的环节。" },
  { phase: "第 04 阶段", date: "2025.01", title: "独家档案公开：我们看到的完整真相", body: "在反复核实来源之后，我们把整条时间线、证据与各方说法按可查证口径完整呈现。" },
];

export const features: FeatureItem[] = [
  { tag: "深度专题", title: "一档综艺停播背后：三个月里到底发生了什么", excerpt: "从招商到撤资，从录制中断到一纸公告，我们用 40 天跟进的未公开细节，拼出停播背后的完整因果链。", meta: "专题 · 已更新 12 期", image: "https://readdy.ai/api/search-image?query=minimal%20editorial%20moodboard%20of%20clapperboard%20and%20scattered%20notes%20with%20red%20annotation%20marks%20on%20warm%20cream%20paper%20background%2C%20soft%20side%20light%2C%20investigative%20magazine%20aesthetic%2C%20clean%20composition%2C%20no%20people&width=800&height=560&seq=feature-s1&orientation=landscape" },
  { tag: "独家连载", title: "带货翻车合集 vol.3：那些没被写进战报的退货率", excerpt: "战报里只晒 GMV，我们翻出公开的退单与投诉样本，把“神话”重新拉回可计算的数字层面。", meta: "连载 · 第 3 卷", image: "https://readdy.ai/api/search-image?query=flat%20lay%20editorial%20arrangement%20of%20receipts%20spreadsheets%20and%20red%20circled%20figures%20on%20warm%20off%20white%20surface%2C%20studio%20soft%20light%2C%20minimal%20modern%20design%2C%20no%20people%2C%20clean%20composition&width=800&height=560&seq=feature-s2&orientation=landscape" },
  { tag: "独家档案", title: "一次“道歉”的措辞学：三版声明草稿逐字对照", excerpt: "把对外发布的终稿、流出草稿与内部备忘录并排，看同一句话如何在公关压力下被反复改写。", meta: "档案 · 阅读约 6 分钟", image: "https://readdy.ai/api/search-image?query=editorial%20stack%20of%20typed%20documents%20with%20highlighted%20lines%20and%20handwritten%20revision%20notes%20on%20beige%20paper%2C%20warm%20desk%20lamp%20lighting%2C%20documentary%20style%2C%20no%20people%2C%20clean%20minimal%20layout&width=800&height=560&seq=feature-s3&orientation=landscape" },
];

export const resources: ResourceItem[] = [
  { icon: "ri-article-line", title: "深挖专题合集包 · 2025", desc: "全年深度专题索引与要点整理，一次打包带走。", size: "PDF · 24MB", action: "进入下载" },
  { icon: "ri-file-list-3-line", title: "时间线还原档案", desc: "多起事件从发酵到落地的可查证时间线汇编。", size: "PDF · 18MB", action: "进入下载" },
  { icon: "ri-question-answer-line", title: "首发爆料合集", desc: "标注来源口径的独家爆料与内幕线索整理合集。", size: "网页 · 在线读", action: "进入直达" },
];

export const navLinks = [
  { label: "今日热榜", href: "#hot" },
  { label: "独家档案", href: "#archive" },
  { label: "深挖方向", href: "#direction" },
  { label: "资源入口", href: "#resource" },
];

export const heroStats = [
  { value: "12+", label: "深度专题" },
  { value: "300+", label: "归档线索" },
  { value: "60+", label: "内幕文件" },
];